import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import RootContext from '../../context';
// import success from '../../../assets/success.svg';
// import { StandartPage } from '../../design/StandartPage';
// import { PermissionButton } from '../NoPermission/styles';
import { sendMessageToParent } from '../../utils';
import { PATH_INTRO, PATH_ROOT } from '../../paths';

export const Success = () => {
  const { videoParams } = useContext(RootContext);
  if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  setTimeout(() => sendMessageToParent({ _: 'success' }), 3000);

  // const buttons = <PermissionButton onClick={() => sendMessageToParent({ _: 'success' })}>
  //   Back to website
  // </PermissionButton>;

  return (
    <>success</>
  );
};
/*
    <StandartPage
      image={success}
      title={'Successful'}
      upperText={'Liveness check'}
      underText={'You can now proceed to the website'}
      buttons={null}
    />
 */
